module.exports = __webpack_public_path__ + "media/coins.f9edf61e.mp3";